import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'textAlpha1Hover',
  $names: {
    target: '[data-js-hover=textAlpha1]',
  },
  styleInfo: {
    alphaMouseEnter: 0.5,
    alphaMouseLeave: 1.0,
  },
}

export default class TextAlpha1Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      gsap.killTweensOf($target, 'opacity')
      gsap.to($target, {
        opacity: this.styleInfo.alphaMouseEnter,
        duration: 0.5,
        ease: 'expo.out',
      })
      gsap.delayedCall(0.2, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      gsap.killTweensOf($target, 'opacity')
      gsap.to($target, {
        opacity: this.styleInfo.alphaMouseLeave,
        duration: 0.6,
        ease: 'none',
        delay: 0.05,
      })

      resolve()
    })
  }
}